import { useState, useLayoutEffect, useRef, memo, useMemo, useContext, useEffect } from 'react';
import moment from 'moment';
import { EventContext } from 'pages/events';
import ContactUs, { sourceType } from '@components/shared/widgets/ContactUs';
import { useDispatch } from '@globalStore/storeProvider';
import useMediaQuery from '@utils/hooks/useMediaQuery';
import useStorage from '@utils/hooks/useStorage';
import { EmbedMasterClassEventForm } from '@components/shared/forms/MasterClassEventForm';
import { Primary } from 'stories/Button.stories';
import EventSuccessScreen from '@components/shared/forms/MasterClassEventForm/EventSuccessScreen';
function RegisterSection() {
  const {
    isLive,
    registerLink,
    videoLink,
    eventStartTime,
    eventEndTime,
    titleHighlights,
    registeredCount,
    EventStatus,
    setEventStatus,
    title,
    isWorkshop,
    isMasterClass,
    eventId,
    isLoading,
    setLoading,
    registerWithOneClick,
    ...rest
  } = useContext(EventContext);

  const [isEnded, setIsEnded] = useState(null);
  const isMobile = useMediaQuery('(max-width: 767.98px)');
  const [timerData, setTimerData] = useState({
    timerDays: 0,
    timerHours: 0,
    timerMinutes: 0,
    timerSeconds: 0,
  });

  let interval = useRef();
  const dispatch = useDispatch();

  const setupTimer = (distance) => {
    const twoDigi = (time) => ('0' + Math.floor(time)).slice(-2);
    setTimerData({
      timerDays: twoDigi(distance / (24 * 60 * 60 * 1000)),
      timerHours: twoDigi((distance % (24 * 60 * 60 * 1000)) / (1000 * 60 * 60)),
      timerMinutes: twoDigi((distance % (60 * 60 * 1000)) / (1000 * 60)),
      timerSeconds: twoDigi((distance % (60 * 1000)) / 1000),
    });
  };

  const eventStartTimer = () => {
    const countDownStart = new Date(eventStartTime).getTime();
    const countDownDate = new Date(eventEndTime).getTime();

    interval = setInterval(() => {
      const now = new Date().getTime();
      const distance = countDownDate - now;
      // distance according to live till end time
      if (now < countDownStart) {
        EventStatus !== 'STARTING' && setEventStatus('STARTING');
        setupTimer(countDownStart - now);
      } else if (distance < 0) {
        // Stop Timer
        clearInterval(interval.current);
        setIsEnded(true);
        setEventStatus('END');
      } else {
        // Update Timer
        setupTimer(distance);
        EventStatus !== 'LIVE' && setEventStatus('LIVE');
      }
    }, 1000);
  };

  useLayoutEffect(() => {
    !isEnded && eventStartTimer();
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEnded]);

  const { getItemFromLocal } = useStorage();

  const localFormData = getItemFromLocal('rcb_form_data');

  const isRegisteredKeyExist = getItemFromLocal('isRegistered');
  const registeredEventId = (isRegisteredKeyExist && JSON.parse(isRegisteredKeyExist)) || [];

  const isEventRegister = registeredEventId?.includes(eventId);

  useEffect(() => {
    if (isEventRegister && isLoading) {
      setLoading(false);
    }
  }, [isEventRegister]);

  if (!EventStatus) return null;

  return (
    <>
      <section
        id="RegisterSection"
        className={`w-full flex-row rounded-md bg-white shadow-sm md:flex md:flex-col md:pb-[20px]`}
      >
        {EventStatus === 'END' && (
          <div className="mb-2 flex flex-col gap-y-2 px-6 pt-8">
            <p className="text-base font-extrabold">{title}</p>
            <span className="text-base">Date : {moment(eventStartTime).format('ll')}</span>
          </div>
        )}
        <section className="mb-3 flex flex-row items-end gap-x-2  md:mb-0 md:flex-col md:items-start md:gap-x-4">
          <section
            className={`flex w-full flex-col justify-center gap-4 md:flex-row md:items-center md:justify-start ${
              EventStatus !== 'END' ? 'block md:hidden' : 'block'
            }`}
          >
            {!!EventStatus && !isEnded && (
              <p className="relative whitespace-nowrap px-5 pt-2 text-sm font-thin md:ml-0 md:mr-0 lg:text-base">
                <span className="hidden md:block">
                  {EventStatus === 'STARTING' ? 'Starts in' : 'Ends in'}
                </span>
                <span className="block md:hidden">
                  Event {EventStatus === 'STARTING' ? 'Starts in' : 'Ends in'}
                </span>
              </p>
            )}
            <div className="flex w-full items-center justify-center text-center text-xs md:text-base">
              <section className="mx-auto flex h-full items-center gap-x-1">
                <div className="flex h-14 w-16 flex-col items-center justify-center rounded-md bg-white bg-opacity-70  px-2 py-1 md:h-11 md:w-11 md:py-2">
                  <span className="text-xs font-thin text-gray-400 text-gray-dark">Days</span>
                  <span className="font-satoshi-bold text-sm font-bold ">
                    {timerData.timerDays}
                  </span>
                </div>
                <span className="opacity-80">:</span>
                <div className="flex h-14 w-16 flex-col items-center justify-center rounded-md bg-white bg-opacity-70  px-2 py-1 md:h-11 md:w-11 md:py-2">
                  <span className="text-xs font-thin text-gray-400 text-gray-dark">Hrs</span>
                  <span className="font-satoshi-bold text-sm font-bold ">
                    {timerData.timerHours}
                  </span>
                </div>
                <span className="opacity-80">:</span>
                <div className="flex h-14 w-16 flex-col items-center justify-center rounded-md bg-white bg-opacity-70  px-2 py-1 md:h-11 md:w-11 md:py-2">
                  <span className="text-xs font-thin text-gray-400 text-gray-dark">Min</span>
                  <span className="font-satoshi-bold text-sm font-bold ">
                    {timerData.timerMinutes}
                  </span>
                </div>
                <span className="opacity-80">:</span>
                <div className="flex h-14 w-16 flex-col items-center justify-center rounded-md bg-white bg-opacity-70  px-2 py-1 md:h-11 md:w-11 md:py-2">
                  <span className="text-xs font-thin text-gray-400 text-gray-dark">Sec</span>
                  <span className="font-satoshi-bold text-sm font-bold ">
                    {timerData.timerSeconds}
                  </span>
                </div>
              </section>
            </div>
          </section>
        </section>
        {!!EventStatus && (
          <section
            className={`mx-auto w-11/12 pb-3 text-lg md:p-0 ${
              EventStatus === 'END' ? 'md:mb-6' : ''
            }`}
          >
            {EventStatus === 'END' ? (
              <Primary label={'Registration Closed'} size={'large'} customStyle={'w-full'} />
            ) : (
              <>
                {isMobile && (
                  <Primary
                    size={'large'}
                    label={EventStatus === 'LIVE' ? 'Join Now' : 'Register Now'}
                    onClick={() => {
                      if (window?.localStorage?.getItem('isRegistered') && EventStatus == 'LIVE') {
                        window.open(`${videoLink}`, '_blank');
                      } else {
                        dispatch({
                          type: 'SET_WIDGET_SOURCE',
                          payload: sourceType.eventLandingPage,
                        });
                      }
                    }}
                    customStyle={'w-full'}
                  />
                )}
              </>
            )}
          </section>
        )}
        {EventStatus !== 'END' && (
          <>
            {!isMobile && (!localFormData || isEventRegister) ? (
              <div
                style={{
                  boxShadow:
                    'rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px',
                }}
                className="rounded-lg"
              >
                <EmbedMasterClassEventForm
                  eventData={{
                    ...rest,
                    eventId,
                    registerLink,
                    eventStartTime,
                    eventEndTime,
                    title,
                  }}
                  source={sourceType.eventLandingPage}
                  formContainerStyle={'slim-scroll max-h-[57vh]'}
                  showSuccess={isEventRegister}
                  localFormData={!!localFormData && JSON.parse(localFormData)}
                />
              </div>
            ) : (
              <ContactUs eventPage={false} isBytesPage />
            )}
          </>
        )}

        {EventStatus !== 'END' && registerWithOneClick && (
          <EventSuccessScreen
            {...(!!localFormData ? JSON.parse(localFormData) : {})}
            source={sourceType.eventLandingPage}
            eventData={{
              ...rest,
              eventId,
              registerLink,
              eventStartTime,
              eventEndTime,
              title,
            }}
            isOneClickUI
            container={'hidden'}
          />
        )}
      </section>
    </>
  );
}

export default memo(RegisterSection);
